module.exports = __webpack_public_path__ + "img/sea-1.3b39e1d2.jpg";